import React from 'react';
import DatePicker from 'components/@common/Inputs/DatePicker';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'components/@common/Inputs/Select';
import useEndOfYearProcessing from 'components/EndOfYearProcessing/hooks/use-end-of-year-processing';
import Config from 'config';
import { addBusinessDays, startOfTomorrow, endOfDay, getYear, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { FastFieldProps, Field, FormikProps, useFormikContext } from 'formik';
import { EndOfYearProcessingFormValues, integrationTypes } from '../../types';

const {
  endOfYear: { minAdvanceDays, limitDay }
} = Config;

const EndOfYearProcessingForm: React.FC = () => {
  const { t } = useTranslation('EndOfYearProcessing');
  const { values: initialValues } = useEndOfYearProcessing();
  const { values, setFieldValue }: FormikProps<EndOfYearProcessingFormValues> = useFormikContext();
  const maxDate = endOfDay(new Date(`${limitDay} ${getYear(new Date())}`));

  return (
    <Box display="flex" flexDirection="column" gridGap="0.5rem">
      <Field name="dateTermEnd">
        {({ field, meta }: FastFieldProps) =>
          initialValues.dateTermEnd ? (
            <DatePicker
              {...field}
              value={field.value || null}
              required={true}
              onChange={(date: any) => setFieldValue('dateTermEnd', date)}
              minDate={startOfTomorrow()}
              maxDate={maxDate}
              autoOk={true}
              label={t('End of Year Date')}
              helperText={meta.touched && meta.error}
              error={Boolean(meta.touched && meta.error)}
              KeyboardButtonProps={{
                'aria-label': t('End of Year Date')
              }}
              inputProps={{
                'aria-label': t('End of Year Date')
              }}
            />
          ) : (
            <></>
          )
        }
      </Field>
      <Field name="upcomingDateTermStart">
        {({ field, meta }: FastFieldProps) => (
          <DatePicker
            {...field}
            value={field.value || null}
            onChange={(date: any) => setFieldValue('upcomingDateTermStart', date)}
            minDate={addBusinessDays(
              startOfDay(values.dateTermEnd ? new Date(values.dateTermEnd) : new Date()),
              minAdvanceDays
            )}
            maxDate={maxDate}
            autoOk={true}
            label={t('Requested Set Up Date (requires current year licenses)')}
            helperText={meta.error}
            error={Boolean(meta.error)}
            KeyboardButtonProps={{
              'aria-label': t('Requested Set Up Date')
            }}
            inputProps={{
              'aria-label': t('Requested Set Up Date')
            }}
          />
        )}
      </Field>
      <Field name="upcomingIntegrationType">
        {({ field, meta }: FastFieldProps) => (
          <Select
            {...field}
            size="small"
            margin="normal"
            value={field.value || null}
            label={t('How will you be rostering?')}
            placeholder={t('Select a rostering type')}
            helperText={meta.touched && meta.error}
            error={Boolean(meta.touched && meta.error)}
            inputProps={{
              'aria-label': t('How will you be rostering?')
            }}
          >
            {integrationTypes.map(({ value, label }, idx: number) => (
              <MenuItem key={idx} value={value}>
                {t(label)}
              </MenuItem>
            ))}
          </Select>
        )}
      </Field>
    </Box>
  );
};

export default EndOfYearProcessingForm;
